var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"share-header"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.logo2x}})]),_vm._v(" "),_c('button',{staticClass:"dowload",attrs:{"color":"#FF6907"},on:{"click":_vm.download_app}},[_vm._v(_vm._s(_vm.$t('downloadMsg')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }